/**
 * The Homebase page back control: a 48px circle with a back arrow.
 *
 * For PAGES (past sessions, reports, a report) that have no footer Back/Continue. Task
 * flows keep their footer Back from `StepShell` instead. 48px is the touch-target floor
 * on a phone-first surface, and a circle reads as a control where the old "‹ Home" text
 * link read as a label. Icon-only, so `label` is its accessible name ("Back to home").
 */
export function BackButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      className="flex h-12 w-12 shrink-0 cursor-pointer items-center justify-center self-start rounded-full border border-border bg-surface text-primary transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-interactive focus-visible:ring-offset-2"
    >
      <svg
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="h-5 w-5"
      >
        <path d="M16 10H4M9 5l-5 5 5 5" />
      </svg>
    </button>
  );
}
